import type { BusinessType, Goal } from 'types'

export interface GoalOption {
  id: Goal
  category: string
  title: string
  description: string
  isRecommended?: boolean
}

export const GOAL_OPTIONS_BY_BUSINESS_TYPE: Record<BusinessType, GoalOption[]> = {
  service: [
    {
      id: 'grow_audience',
      category: 'Awareness',
      title: 'Grow Your Audience',
      description: "Reach new potential clients who haven't discovered you yet.",
      isRecommended: true,
    },
    {
      id: 'generate_leads',
      category: 'Consideration',
      title: 'Generate Leads',
      description: "Help prospects understand what you do and why you're the right fit.",
    },
    {
      id: 'convert_clients',
      category: 'Conversion',
      title: 'Convert Clients',
      description: 'Turn interested prospects into paying clients.',
    },
    {
      id: 'drive_repeat_business',
      category: 'Expansion',
      title: 'Drive Repeat Business',
      description: 'Keep past clients coming back and referring others to you.',
    },
  ],
  place: [
    {
      id: 'get_found_locally',
      category: 'Awareness',
      title: 'Get Found Locally',
      description: "Reach people nearby who need what you offer but haven't found you yet.",
      isRecommended: true,
    },
    {
      id: 'bring_in_new_customers',
      category: 'Consideration',
      title: 'Bring In New Customers',
      description: 'Get people to visit, book, or reach out for the first time',
    },
    {
      id: 'keep_customers_coming_back',
      category: 'Conversion',
      title: 'Keep Customers Coming Back',
      description: 'Turn first-time visitors into regulars.',
    },
    {
      id: 'grow_through_word_of_mouth',
      category: 'Expansion',
      title: 'Grow Through Word-of-Mouth',
      description: 'Turn happy customers into advocates who spread the word.',
    },
  ],
  product: [
    {
      id: 'grow_audience',
      category: 'Awareness',
      title: 'Grow Your Audience',
      description: "Reach shoppers who haven't discovered your brand yet.",
      isRecommended: true,
    },
    {
      id: 'build_product_awareness',
      category: 'Consideration',
      title: 'Build Awareness',
      description: 'Show shoppers why your products are worth buying.',
    },
    {
      id: 'make_more_sales',
      category: 'Conversion',
      title: 'Make More Sales',
      description: 'Turn browsers into buyers with the right offer at the right time.',
    },
    {
      id: 'create_repeat_customers',
      category: 'Expansion',
      title: 'Create Repeat Customers',
      description: 'Turn one-time buyers into loyal customers.',
    },
  ],
}

export const BUSINESS_TYPE_LABELS: Record<BusinessType, string> = {
  service: 'service based',
  place: 'place based',
  product: 'product based',
}
